(function () {
  var STORAGE_KEY = "theme:wishlist";
  var config = window.__wishlist || {};

  // ── localStorage with 30-day expiry ──────────────────────────────

  var THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

  function getLocalList() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      if (!raw.items) return [];
      if (raw.expires && Date.now() > raw.expires) {
        localStorage.removeItem(STORAGE_KEY);
        return [];
      }
      return raw.items;
    } catch (e) {
      return [];
    }
  }

  function saveLocalList(list) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          items: list,
          expires: Date.now() + THIRTY_DAYS,
        }),
      );
    } catch (e) {
      /* private browsing */
    }
  }

  // ── In-memory cache ─────────────────────────────────────────────

  function buildInitialCache() {
    var liquid = config.initialWishlist;
    var local = getLocalList();
    if (liquid && liquid.length) return liquid;
    if (local && local.length) return local;
    return [];
  }

  var cache = buildInitialCache();

  function isInCache(pid) {
    return cache.indexOf(Number(pid)) !== -1;
  }

  // ── Toggle ──────────────────────────────────────────────────────

  function toggle(productId) {
    productId = Number(productId);
    var idx = cache.indexOf(productId);
    var adding = idx === -1;

    if (adding) {
      cache.push(productId);
    } else {
      cache.splice(idx, 1);
    }

    saveLocalList(cache);

    return adding;
  }

  // ── UI sync ─────────────────────────────────────────────────────

  function syncButtons(productId, added) {
    var label = added ? "Remove from wishlist" : "Add to wishlist";
    document
      .querySelectorAll('.cl-wishlist-button[data-product-id="' + productId + '"]')
      .forEach(function (btn) {
        btn.setAttribute("aria-pressed", String(added));
        btn.setAttribute("aria-label", label);
      });
  }

  function syncAll() {
    document.querySelectorAll(".cl-wishlist-button").forEach(function (btn) {
      var pid = btn.dataset.productId;
      if (pid && isInCache(pid)) {
        btn.setAttribute("aria-pressed", "true");
        btn.setAttribute("aria-label", "Remove from wishlist");
      }
    });
  }

  // ── Click handler ───────────────────────────────────────────────

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".cl-wishlist-button");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var productId = btn.dataset.productId;
    if (!productId) return;

    if (!config.isLoggedIn && !document.getElementById("wishlist-page-root")) {
      var drawer = document.getElementById("wishlist-login-drawer");
      if (drawer && typeof drawer.show === "function") {
        drawer.dataset.pendingProduct = productId;
        drawer.show();
      } else if (config.loginUrl) {
        window.location.href = config.loginUrl;
      }
      return;
    }
    var added = toggle(productId);
    syncButtons(productId, added);

    if (!added && document.getElementById("wishlist-page-root")) {
      var card = btn.closest(".custom-product-card, .product-card");
      if (card) {
        card.style.transition = "opacity 0.3s, transform 0.3s";
        card.style.opacity = "0";
        card.style.transform = "scale(0.95)";
        setTimeout(function () {
          card.remove();
          var root = document.getElementById("wishlist-page-root");
          var countEl = root.querySelector(".cl-wishlist-page__count");
          var remaining = root.querySelectorAll(
            ".custom-product-card, .product-card",
          ).length;
          if (countEl) {
            countEl.textContent =
              remaining + (remaining === 1 ? " item" : " items");
          }
          if (remaining === 0) {
            root.innerHTML =
              '<div class="cl-wishlist-page__empty"><p>Your wishlist is empty.</p>' +
              '<a href="/collections" class="button">Continue Shopping</a></div>';
          }
        }, 300);
        return;
      }
    }

    btn.classList.remove("cl-wishlist-button--animating");
    void btn.offsetWidth;
    btn.classList.add("cl-wishlist-button--animating");
  });

  // ── Guest continue: save pending product then go to wishlist ────

  document.addEventListener("click", function (e) {
    var link = e.target.closest(".cl-wishlist-guest-continue");
    if (!link) return;

    var drawer = document.getElementById("wishlist-login-drawer");
    var pendingId = drawer && drawer.dataset.pendingProduct;
    if (pendingId) {
      var pid = Number(pendingId);
      if (cache.indexOf(pid) === -1) {
        cache.push(pid);
        saveLocalList(cache);
        syncButtons(pendingId, true);
      }
      delete drawer.dataset.pendingProduct;
    }
  });

  // ── Re-sync when wishlist page injects new cards ─────────────────

  document.addEventListener("wishlist:sync", function () {
    syncAll();
  });

  // ── Init ────────────────────────────────────────────────────────

  document.addEventListener("DOMContentLoaded", function () {
    syncAll();
  });
})();
